export const widgetStyles = /* css */ `
  :host {
    /* Atom One Dark palette */
    --snitch-bg: #282c34;
    --snitch-bg-soft: #21252b;
    --snitch-bg-elev: #2c313a;
    --snitch-border: #3e4451;
    --snitch-text: #abb2bf;
    --snitch-text-dim: #9da5b4;
    --snitch-accent: #61afef;
    --snitch-accent-strong: #82c0ff;
    --snitch-accent-deep: #4078a8;
    --snitch-danger: #e06c75;
    --snitch-success: #98c379;
    --snitch-radius: 14px;
    --snitch-shadow: 0 20px 60px -10px rgba(0, 0, 0, 0.6),
      0 0 0 1px rgba(97, 175, 239, 0.10);

    all: initial;
    font-family: ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto,
      "Helvetica Neue", Arial, sans-serif;
    color: var(--snitch-text);
    line-height: 1.45;
  }

  *, *::before, *::after { box-sizing: border-box; }
  button { font-family: inherit; }

  .toggle {
    position: fixed;
    z-index: 2147483646;
    bottom: 18px; right: 18px;
    width: 26px; height: 26px;
    border-radius: 999px;
    border: 0;
    background: linear-gradient(135deg, var(--snitch-accent), var(--snitch-accent-deep));
    color: #fff;
    cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    box-shadow: 0 4px 14px -4px rgba(97, 175, 239, 0.55),
                0 1px 4px rgba(0,0,0,0.3);
    transition: transform 120ms ease, box-shadow 120ms ease;
  }
  .toggle:hover { transform: translateY(-1px) scale(1.06); }
  .toggle:active { transform: translateY(0) scale(0.96); }
  .toggle[data-position="bottom-left"]  { left: 18px; right: auto; }
  .toggle[data-position="top-right"]    { top: 18px; bottom: auto; }
  .toggle[data-position="top-left"]     { top: 18px; left: 18px; bottom: auto; right: auto; }
  .toggle svg { width: 12px; height: 12px; }

  .panel {
    /* Floating panel — no backdrop overlay so users can see the page they're
       reporting on. Strong shadow + border keep it visually distinct. */
    position: fixed;
    z-index: 2147483647;
    bottom: 22px; right: 22px;
    width: 420px; max-width: calc(100vw - 44px);
    max-height: calc(100vh - 44px);
    overflow: auto;
    background: var(--snitch-bg);
    border: 1px solid var(--snitch-border);
    border-radius: var(--snitch-radius);
    box-shadow: var(--snitch-shadow);
    display: flex; flex-direction: column;
  }

  .header {
    padding: 14px 16px;
    display: flex; align-items: center; justify-content: space-between;
    border-bottom: 1px solid var(--snitch-border);
  }
  .title-row {
    display: flex; align-items: center; gap: 10px;
    flex: 1;
    cursor: grab;
    user-select: none;
    -webkit-user-select: none;
    touch-action: none;
  }
  .title-row[data-dragging="true"] { cursor: grabbing; }
  .dot { width: 8px; height: 8px; border-radius: 999px; background: var(--snitch-accent-strong); box-shadow: 0 0 12px var(--snitch-accent); }
  .header h2 { font-size: 14px; font-weight: 600; margin: 0; letter-spacing: 0.2px; color: #e6e6e6; }
  .close {
    background: transparent; border: 0; color: var(--snitch-text-dim);
    cursor: pointer; padding: 4px; border-radius: 6px;
  }
  .close:hover { color: var(--snitch-text); background: var(--snitch-bg-soft); }

  .body { padding: 14px 16px 4px; display: flex; flex-direction: column; gap: 12px; }

  label.field { display: flex; flex-direction: column; gap: 6px; }
  label.field > span { font-size: 11px; color: var(--snitch-text-dim); text-transform: uppercase; letter-spacing: 0.6px; }

  input[type="text"], textarea {
    width: 100%;
    background: var(--snitch-bg-soft);
    border: 1px solid var(--snitch-border);
    color: var(--snitch-text);
    border-radius: 9px;
    padding: 9px 11px;
    font: inherit;
    font-size: 13px;
    resize: vertical;
    outline: none;
    transition: border-color 120ms ease, box-shadow 120ms ease;
  }
  textarea { min-height: 84px; }
  input[type="text"]:focus, textarea:focus {
    border-color: var(--snitch-accent);
    box-shadow: 0 0 0 3px rgba(97, 175, 239, 0.18);
  }

  .actions-row { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
  .actions-row.three { grid-template-columns: 1fr 1fr 1fr; }

  .chip {
    background: var(--snitch-bg-soft);
    border: 1px solid var(--snitch-border);
    color: var(--snitch-text);
    border-radius: 9px;
    padding: 9px 10px;
    cursor: pointer;
    font-size: 12px;
    display: flex; align-items: center; justify-content: center; gap: 6px;
    transition: background 120ms ease, border-color 120ms ease, transform 80ms ease;
  }
  .chip:hover { background: var(--snitch-bg-elev); border-color: var(--snitch-accent); }
  .chip:active { transform: scale(0.98); }
  .chip[data-active="true"] { border-color: var(--snitch-accent); background: rgba(97, 175, 239, 0.16); }
  .chip[data-recording="true"] { border-color: var(--snitch-danger); color: var(--snitch-danger); }
  .chip svg { width: 14px; height: 14px; }

  .preview {
    display: flex; flex-direction: column; gap: 6px;
    padding: 10px;
    border: 1px dashed var(--snitch-border);
    border-radius: 9px;
    background: var(--snitch-bg-soft);
  }
  .preview .meta { display: flex; align-items: center; justify-content: space-between; font-size: 11px; color: var(--snitch-text-dim); }
  .preview .meta-actions { display: flex; align-items: center; gap: 8px; }
  .preview button.meta-btn {
    background: transparent;
    border: 1px solid var(--snitch-border);
    color: var(--snitch-text-dim);
    border-radius: 6px;
    padding: 3px 8px;
    cursor: pointer;
    font: inherit;
    font-size: 11px;
    display: inline-flex; align-items: center; gap: 4px;
    transition: color 120ms ease, border-color 120ms ease, background 120ms ease;
  }
  .preview button.meta-btn:hover { color: var(--snitch-text); border-color: var(--snitch-accent); background: var(--snitch-bg-elev); }
  .preview button.meta-btn:disabled { opacity: 0.5; cursor: not-allowed; }
  .preview button.meta-btn svg { width: 11px; height: 11px; }
  .preview button.unset { background: transparent; border: 0; color: var(--snitch-danger); cursor: pointer; font-size: 11px; }
  .preview img { width: 100%; max-height: 140px; object-fit: cover; border-radius: 6px; }
  .preview audio { width: 100%; }
  .preview video { width: 100%; max-height: 200px; border-radius: 6px; background: #000; }

  .footer {
    padding: 12px 16px 16px;
    border-top: 1px solid var(--snitch-border);
    margin-top: 8px;
    display: flex; justify-content: flex-end; gap: 8px;
  }
  .btn {
    border: 0; cursor: pointer; padding: 9px 14px; border-radius: 9px;
    font-size: 13px; font-weight: 500;
    transition: filter 120ms ease, background 120ms ease;
  }
  .btn-ghost { background: transparent; color: var(--snitch-text-dim); }
  .btn-ghost:hover { color: var(--snitch-text); }
  .btn-primary {
    background: linear-gradient(135deg, var(--snitch-accent), var(--snitch-accent-deep));
    color: #fff;
    box-shadow: 0 4px 18px -4px rgba(97, 175, 239, 0.5);
  }
  .btn-primary:hover { filter: brightness(1.06); }
  .btn-primary:disabled { opacity: 0.5; cursor: not-allowed; box-shadow: none; }

  .status {
    font-size: 12px; padding: 8px 10px; border-radius: 8px;
    background: var(--snitch-bg-soft);
    border: 1px solid var(--snitch-border);
    color: var(--snitch-text-dim);
  }
  .status[data-tone="error"] { color: var(--snitch-danger); border-color: rgba(224, 108, 117, 0.4); }
  .status[data-tone="success"] { color: var(--snitch-success); border-color: rgba(152, 195, 121, 0.4); }

  @media (max-width: 520px) {
    .panel {
      bottom: 0; right: 0; left: 0; top: 0;
      width: 100%; max-width: 100%; max-height: 100vh;
      border-radius: 0;
    }
  }
`;
